"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncBatch = asyncBatch;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

async function* asyncBatch(source, size) {
  let batch = [];

  for await (const item of source) {
    batch.push(item);

    if (batch.length === size) {
      yield batch;
      batch = [];
    }
  }

  if (batch.length) {
    yield batch;
  }
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncBatch, {
  validateArgs([size]) {
    if (typeof size !== 'number' || size < 1) {
      throw new TypeError('batch size should be a number greater than zero');
    }
  }

});

exports.default = _default;